import * as common from 'store/modules/common'
import { api } from './api'
import { getComponentKey } from 'utils/getComponentKey'
import { getPersisted, persist } from 'utils/persistor'

export const prefix = 'staticFilters'

export { api }
export const initialState = {
  ...common.initialState,
  entity: [],
  activeTab: getPersisted(prefix, 0)
}
export const actionTypes = {
  ...common.actionTypes(prefix),
  activeTab: `${prefix}/activeTab`,
  lastSavedId: null
}
export const actionCreators = {
  ...common.actionCreators(prefix, api),
  get: (page) => ({
    type: actionTypes.entity,
    payload: () => api.getByPage(page)
  }),
  setActiveTab: (activeTab) => ({
    type: actionTypes.activeTab,
    payload: activeTab
  })
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case `${prefix}/${common.suffix.entity}${common.suffix.fetched}`: {
      const items = common.processResponse(action.payload)
      const index = items.findIndex(x => x.id === state.lastSavedId)
      const activeTab = (index !== -1 ? index : state.activeTab)
      return { ...state, fetching: false, error: null, entity: items, activeTab, lastSavedId: null }
    }
    case `${actionTypes.saved}`: return { ...state, saving: false, lastSavedId: (action.payload || {}).id, gridKey: getComponentKey() }
    case `${actionTypes.deleted}`: {
      persist(prefix, 0)
      return { ...state, deleting: false, gridKey: getComponentKey(), activeTab: 0 }
    }
    case `${actionTypes.activeTab}`: {
      persist(prefix, action.payload)
      return { ...state, activeTab: action.payload }
    }
    default: return common.reducer(state, action, prefix)
  }
}

